import { Box, Grid, Typography } from '@mui/material'
import { DragAndDrop } from '~/components/Form/DragAndDrop'
import { useContract } from '~/contexts'
import { CustomerFileModel, CustomerModel, DocumentationAnalysisFileModel, ECustomerFileType, EPersonType, EProposalFileType } from '~/graphql/types'

export type DocumentationFieldsProps = {
  personType?: EPersonType
  disableFields?: boolean
  currentCustomer: CustomerModel | null
}
export const DocumentationFields: React.FC<DocumentationFieldsProps> = (props) => {
  const { personType, disableFields, currentCustomer } = props
  const { contract } = useContract()
  const isFormalized = Boolean(contract?.isFormalizedByPartner)

  // PF: RG/CNH frente/verso
  const customerFrontDocument = isFormalized
    ? contract?.files?.find(file => file.type === EProposalFileType.customerPfDocumentWithPhotoFront)
    : currentCustomer?.files?.find(file => file.type === ECustomerFileType.customerPfDocumentWithPhotoFront)

  const customerBackDocument = isFormalized
    ? contract?.files?.find(file => file.type === EProposalFileType.customerPfDocumentWithPhotoBack)
    : currentCustomer?.files?.find(file => file.type === ECustomerFileType.customerPfDocumentWithPhotoBack)

  // PJ: Contrato social e Cartão CNPJ
  const customerPjDocumentCardDocument = isFormalized
    ? contract?.files?.find(file => file.type === EProposalFileType.customerPjDocumentCard)
    : currentCustomer?.files?.find(file => file.type === ECustomerFileType.customerPjDocumentCard)

  const customerPjSocialContractDocument = isFormalized
    ? contract?.files?.find(file => file.type === EProposalFileType.customerPjSocialContract)
    : currentCustomer?.files?.find(file => file.type === ECustomerFileType.customerPjSocialContract)

  if (personType === EPersonType.pf) {
    return (
      <>
        <Typography variant='h3' fontWeight={500}>Documentação</Typography>
        <Grid spacing={3} container>
          <Grid item md={6} xs={12}>
            <DragAndDrop
              disabled={disableFields}
              label='Anexar RG ou CNH (Frente)'
              name='customerPfDocumentWithPhotoFront'
              fileDescription='(JPG, JPEG, PNG, PDF. Tamanho máximo 15MB)'
              $variant='secondary'
              status={isFormalized ? (customerFrontDocument as DocumentationAnalysisFileModel)?.status : null}
              sentAt={isFormalized ? (customerFrontDocument as DocumentationAnalysisFileModel)?.sentAt : (customerFrontDocument as CustomerFileModel)?.sendAt}
              $completed={Boolean(isFormalized ? (customerFrontDocument as DocumentationAnalysisFileModel)?.sentAt : (customerFrontDocument as CustomerFileModel)?.sendAt)}
              fileName={customerFrontDocument?.file?.fileName}
              fileKey={customerFrontDocument?.file?.key}
              fileUrl={customerFrontDocument?.file?.key ? `${process.env.VITE_APP_REST_API_URL}files/download/file/${customerFrontDocument?.file?.key}` : customerFrontDocument?.file?.fileUrl}
              accepted={{
                images: true,
                pdf: true
              }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <DragAndDrop
              disabled={disableFields}
              $variant='secondary'
              label='Anexar RG ou CNH (Verso)'
              name='customerPfDocumentWithPhotoBack'
              status={isFormalized ? (customerBackDocument as DocumentationAnalysisFileModel)?.status : null}
              sentAt={isFormalized ? (customerBackDocument as DocumentationAnalysisFileModel)?.sentAt : (customerBackDocument as CustomerFileModel)?.sendAt}
              $completed={Boolean(isFormalized ? (customerBackDocument as DocumentationAnalysisFileModel)?.sentAt : (customerBackDocument as CustomerFileModel)?.sendAt)}
              fileName={customerBackDocument?.file?.fileName}
              fileKey={customerBackDocument?.file?.key}
              fileUrl={customerBackDocument?.file?.key ? `${process.env.VITE_APP_REST_API_URL}files/download/file/${customerBackDocument?.file?.key}` : customerBackDocument?.file?.fileUrl}
              fileDescription='(JPG, JPEG, PNG, PDF. Tamanho máximo 15MB)'
              accepted={{
                images: true,
                pdf: true
              }}
            />
          </Grid>
        </Grid>
      </>
    )
  }

  return (
    <>
      <Typography variant='h3' fontWeight={500}>Documentação</Typography>
      <Box>
        <Typography variant='body2' fontWeight={500} marginBottom={2}>Contrato social</Typography>
        <DragAndDrop
          disabled={disableFields}
          label='Anexar contrato social'
          name='customerPjSocialContract'
          fileDescription='(JPG, JPEG, PNG, PDF. Tamanho máximo 15MB)'
          $variant='secondary'
          status={isFormalized ? (customerPjSocialContractDocument as DocumentationAnalysisFileModel)?.status : null}
          sentAt={isFormalized ? (customerPjSocialContractDocument as DocumentationAnalysisFileModel)?.sentAt : (customerPjSocialContractDocument as CustomerFileModel)?.sendAt}
          $completed={Boolean(isFormalized ? (customerPjSocialContractDocument as DocumentationAnalysisFileModel)?.sentAt : (customerPjSocialContractDocument as CustomerFileModel)?.sendAt)}
          fileName={customerPjSocialContractDocument?.file?.fileName}
          fileKey={customerPjSocialContractDocument?.file?.key}
          fileUrl={customerPjSocialContractDocument?.file?.key ? `${process.env.VITE_APP_REST_API_URL}files/download/file/${customerPjSocialContractDocument?.file?.key}` : customerPjSocialContractDocument?.file?.fileUrl}
        />
      </Box>

      <Box>
        <Typography variant='body2' fontWeight={500} marginBottom={2}>Cartão CNPJ</Typography>
        <DragAndDrop
          disabled={disableFields}
          label='Anexar cartão CNPJ'
          name='customerPjDocumentCard'
          fileDescription='(JPG, JPEG, PNG, PDF. Tamanho máximo 15MB)'
          $variant='secondary'
          status={isFormalized ? (customerPjDocumentCardDocument as DocumentationAnalysisFileModel)?.status : null}
          sentAt={isFormalized ? (customerPjDocumentCardDocument as DocumentationAnalysisFileModel)?.sentAt : (customerPjDocumentCardDocument as CustomerFileModel)?.sendAt}
          $completed={Boolean(isFormalized ? (customerPjDocumentCardDocument as DocumentationAnalysisFileModel)?.sentAt : (customerPjDocumentCardDocument as CustomerFileModel)?.sendAt)}
          fileName={customerPjDocumentCardDocument?.file?.fileName}
          fileKey={customerPjDocumentCardDocument?.file?.key}
          fileUrl={customerPjDocumentCardDocument?.file?.key ? `${process.env.VITE_APP_REST_API_URL}files/download/file/${customerPjDocumentCardDocument?.file?.key}` : customerPjDocumentCardDocument?.file?.fileUrl}
        />
      </Box>
    </>
  )
}
